import styled from 'styled-components/macro';

export const Container = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 50px;
`;

export const FilterOptions = styled.div`
  display: flex;
`;
